<div *ngIf="loading$ | async" class="spinner">
  <mat-spinner></mat-spinner>
</div>

<h1 class="table__title">{{folder?.propertiesObj?.FolderName}}</h1>

<div *ngIf="!(loading$ | async)" class="table__container">
  <ng-template #noFolders>
    <h3>No Folders</h3>
  </ng-template>


  <table *ngIf="folder?.subFolders?.length > 0;else noFolders" class="table__inner" mat-table [dataSource]="dataSource"
    matSort (matSortChange)="applySort($event)">


    <ng-container matColumnDef="FolderName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let element">{{ element?.propertiesObj.FolderName }}</td>
    </ng-container>

    <ng-container matColumnDef="FolderDescription">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
      <td mat-cell *matCellDef="let element">{{ element?.propertiesObj.FolderDescription }}</td>
    </ng-container>

    <ng-container matColumnDef="Settings" *ngIf="(userRoles$ | async)?.superUser">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Settings </th>
      <td mat-cell *matCellDef=" let element"><a [routerLink]="['../..','folderSettings',element.id]"><img
            src="assets/images/icon-reset.svg" /></a></td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef=" displayedColumns$ | async;sticky: true">
    </tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns$ | async" [routerLink]="['..',row.id]"></tr>
  </table>

</div>
<mat-paginator class="table__pagination" [pageSizeOptions]="[100,50,10,5]" (page)="paged($event)"></mat-paginator>
